import { NB } from '@cerebral-inc/ui';
import { ProgressBarProps } from '../types';

const { Progress, Flex, Box } = NB;
export const ProgressBar = ({ stepPercent }: ProgressBarProps) => {
  return (
    <Flex w="100%" mb="40px" mt="-2px">
      <Box>
        <Progress
          value={stepPercent}
          h={stepPercent > 0 ? '4px' : '1px'}
          bg="#F0F1F5"
          _filledTrack={{ bg: '#7D70D2' }}
        />
      </Box>
    </Flex>
  );
};

export default ProgressBar;
